import { render } from "./GameSearch.vue?vue&type=template&id=8d0b91e8&scoped=true"
import script from "./GameSearch.vue?vue&type=script&lang=js"
export * from "./GameSearch.vue?vue&type=script&lang=js"

import "./GameSearch.vue?vue&type=style&index=0&id=8d0b91e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0b91e8"]])

export default __exports__